import HTMLReactParser from './index.js';
export var domToReact = HTMLReactParser.domToReact;
export var htmlToDOM = HTMLReactParser.htmlToDOM;
export var attributesToProps = HTMLReactParser.attributesToProps;
export var Element = HTMLReactParser.Element;
export default HTMLReactParser;